export function formatCurrency(value) {
    if (isNaN(value)) return value;
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

/**
 * Igual a formatCurrency, mas envolve valores negativos em <span class="text-danger fw-bold">.
 * Use em células de tabela JSX.
 */
export function fmtCurrency(value) {
    const num = Number(value);
    const formatted = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(isNaN(num) ? 0 : num);
    if (isNaN(num) || num >= 0) return formatted;
    return <span className="text-danger fw-bold">{formatted}</span>;
}

export function unformatCurrency(value) {
    return value.replace(/\D/g, '') / 100;
}